import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

// Fetches the completed order Healthlink assembled from the GP's Integrated
// Browser submission (KIN-1390, flow step 6).
//
// `downloaded: false` is a normal answer — Healthlink has nothing ready yet — not
// an error, so callers must not treat it as a failed order. The call is idempotent
// server-side: once the document is held, a repeat call answers true without
// contacting Healthlink again.
//
// This says nothing about whether the laboratory accepted the order; that arrives
// separately as the hospital's acknowledgement and shows in `submissionStatus`.
export const useDownloadLabOrder = () => {
  const queryClient = useQueryClient();
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useMutation({
    meta: { skipGlobalError: true },
    mutationFn: async (labOrderId) => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.post(
        `${tenantVal}/healthlink/lab-orders/${labOrderId}/download`
      );

      return response.data;
    },
    onSuccess: (_result, labOrderId) => {
      queryClient.invalidateQueries({ queryKey: ["labOrdersList"] });
      queryClient.invalidateQueries({ queryKey: ["labOrder", labOrderId] });
    },
  });
};
